import { render } from "./CharacterCard.vue?vue&type=template&id=77785ce0"
import script from "./CharacterCard.vue?vue&type=script&lang=ts"
export * from "./CharacterCard.vue?vue&type=script&lang=ts"

import "./CharacterCard.vue?vue&type=style&index=0&id=77785ce0&lang=scss"
script.render = render

export default script